import script from "./NotificationsPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsPortal.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./NotificationsPortal.vue?vue&type=style&index=0&id=3435a756&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__